const dynamicModuleRegistry = require('dynamic-module-registry');

export default {
  actor: dynamicModuleRegistry.get('actor') || {},
  offer: (dynamicModuleRegistry.get('offers') || {}).selectedOffer,
  ilocLocker: dynamicModuleRegistry.get('ilocLocker') || {},
  loanAppProperties: dynamicModuleRegistry.get('loanAppProperties') || {},
  agreementLinks: dynamicModuleRegistry.get('agreementLinks') || {},
  cleanSweepHeapTrackingAttr: dynamicModuleRegistry.get('cleanSweepHeapTrackingAttr') || {},
  error: dynamicModuleRegistry.get('error'),
  experiments: dynamicModuleRegistry.get('experience') || {},
  referrer: dynamicModuleRegistry.get('referrer') || {},
  ilocLanding: dynamicModuleRegistry.get('ilocLanding') || '',
};

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/iloc/iloc.scss');